import { COMMON } from "constants/types";

const initState = {
	closed: [],
	opened: []
};

const Reports = (state = initState, action) => {

	const { type, payload} = action;

	switch(type) {

		case COMMON.REPORTS:

			const sortedData = {};
			const closed = payload.data.closed_reports;
			const open = payload.data.open_reports;

			return {
				...state,
				closed: {...Object.keys(closed)
						.map(key => sortedData[key] = closed[key])},
				opened: {...Object.keys(open)
						.map(key => sortedData[key] = open[key])
				}
			}

		default:
			return state
	}
}



export default Reports;
